import React from "react";
import { useSearchParams, Navigate } from "react-router-dom";
import Mines from "@/pages/Mines";
import Dice from "@/pages/Dice";
import Crash from "@/pages/Crash";
import CoinFlip from "@/pages/CoinFlip";
import Roulette from "@/pages/Roulette";
import Blackjack from "@/pages/Blackjack";
import Baccarat from "@/pages/Baccarat";
import Slots from "@/pages/Slots";
import HiLo from "@/pages/HiLo";
import Plinko from "@/pages/Plinko";
import Keno from "@/pages/Keno";
import DragonTower from "@/pages/DragonTower";
import { nativeGamePath } from "@/casino/nativeGames";
import MobileShell from "./ui/MobileShell";
import MobileHome from "./screens/MobileHome";
import MobileCasino from "./screens/MobileCasino";
import MobileCasinoGame from "./screens/MobileCasinoGame";
import MobileSportsbook from "./screens/MobileSportsbook";
import MobileEvent from "./screens/MobileEvent";
import MobileMyBets from "./screens/MobileMyBets";
import MobileWallet from "./screens/MobileWallet";
import MobileRewards from "./screens/MobileRewards";
import MobileAccount from "./screens/MobileAccount";
import MobileIDCapture from "./screens/MobileIDCapture";
import MobileSignIn from "./screens/MobileSignIn";
import MobileRegister from "./screens/MobileRegister";
import { MobilePrefsProvider } from "./ui/MobilePrefs";
import { SheetProvider } from "./ui/SheetHost";

/* Thin adapters that let App.js branch individual customer routes to the mobile
   layer without duplicating the whole route table. The desktop branches in App.js
   are left byte-for-byte unchanged; only these mobile elements are new. Each
   screen is wrapped in MobileShell (persistent chrome; bare screens hide it via
   useChrome({bare:true})). */

export function MobileProviders({ children }) {
  return (
    <MobilePrefsProvider>
      <SheetProvider>{children}</SheetProvider>
    </MobilePrefsProvider>
  );
}

const wrap = (Screen) => () => (
  <MobileShell>
    <Screen />
  </MobileShell>
);

export const MobileHomeScreen = wrap(MobileHome);
export const MobileMinesScreen = wrap(Mines);
export const MobileDiceScreen = wrap(Dice);
export const MobileCrashScreen = wrap(Crash);
export const MobileCoinFlipScreen = wrap(CoinFlip);
export const MobileRouletteScreen = wrap(Roulette);
export const MobileBlackjackScreen = wrap(Blackjack);
export const MobileBaccaratScreen = wrap(Baccarat);
export const MobileSlotsScreen = wrap(Slots);
export const MobileHiLoScreen = wrap(HiLo);
export const MobilePlinkoScreen = wrap(Plinko);
export const MobileKenoScreen = wrap(Keno);
export const MobileDragonTowerScreen = wrap(DragonTower);
export const MobileSportsbookScreen = wrap(MobileSportsbook);
export const MobileEventScreen = wrap(MobileEvent);
export const MobileMyBetsScreen = wrap(MobileMyBets);
export const MobileWalletScreen = wrap(MobileWallet);
export const MobileRewardsScreen = wrap(MobileRewards);
export const MobileAccountScreen = wrap(MobileAccount);
export const MobileIDCaptureScreen = wrap(MobileIDCapture);
export const MobileSignInScreen = wrap(MobileSignIn);
export const MobileRegisterScreen = wrap(MobileRegister);
// Native Originals + native live tables (blackjack/slots/
// baccarat/live/liveblackjack) host — reachable at /casino/play/:slug.
export const MobileCasinoGameScreen = wrap(MobileCasinoGame);

export function MobileCasinoScreen() {
  const [sp] = useSearchParams();
  const game = sp.get("game");
  // Deep-linked native game (?game=… from Home/marketing links) → the dedicated mobile
  // game host. The old path rendered <Shell><Casino/>, but Casino strips the ?game= param
  // on mount, which made the mobile lobby re-render and fall back — so the game flashed
  // then vanished. Redirecting to /casino/play/:slug opens the game for real.
  if (game) return <Navigate to={nativeGamePath(game)} replace />;
  return (
    <MobileShell>
      <MobileCasino />
    </MobileShell>
  );
}

